<!-- Modals -->
<app-deprecated-modal-form
    #editFormBasicInformation
    [form]="editFormBasicInformationForm"
    (save)="filterNullValuesFromGendersAndPronouns(); onSave()"
    (cancel)="onCancel()"
    headerText="{{ 'employees.personal.editBasicInformation' | appTranslate }}"
    [disabled]="editFormBasicInformationForm?.isAudioRecording"
>
    <app-form-basic-information
        #editFormBasicInformationForm
        [employee]="employee"
        [description]="basicInformationModalDescription"
        (addPendoTrackingForGenders)="setAddPendoTrackingForGenders($event)"
        (addPendoTrackingForPronouns)="setAddPendoTrackingForPronouns($event)"
        *permission="editBasicInformationPermission"
    ></app-form-basic-information>

    <app-form-data-fields
        *ngIf="editFormBasicInformation.isOpen"
        [employee]="employee"
        [dataFieldGroup]="defaultGroupFieldNames.basic_information"
        [dataFields]="editableDataFields"
        [(dataValues)]="dataValues"
        [isDefaultGroup]="true"
    ></app-form-data-fields>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    [form]="editFormPersonalInformationForm"
    #editFormPersonalInformation
    (save)="onSave()"
    (cancel)="onCancel()"
    headerText="{{ 'employees.personal.editPersonalInformation' | appTranslate }}"
>
    <app-form-personal-information
        #editFormPersonalInformationForm
        *permission="editPersonalInformationPermission"
        [account]="account"
        [employee]="employee"
    ></app-form-personal-information>

    <app-form-data-fields
        *ngIf="editFormPersonalInformation.isOpen"
        [employee]="employee"
        [dataFieldGroup]="defaultGroupFieldNames.personal_information"
        [dataFields]="editableDataFields"
        [(dataValues)]="dataValues"
        [isDefaultGroup]="true"
    ></app-form-data-fields>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #editFormAddress
    (save)="onSave()"
    (cancel)="onCancel()"
    headerText="{{ 'employees.personal.editAddress' | appTranslate }}"
>
    <app-form-address #editFormAddressForm [address]="address" *permission="editAddressPermission"></app-form-address>
    <app-form-data-fields
        *ngIf="editFormAddress.isOpen"
        [employee]="employee"
        [dataFieldGroup]="defaultGroupFieldNames.address"
        [dataFields]="editableDataFields"
        [(dataValues)]="dataValues"
        [isDefaultGroup]="true"
    ></app-form-data-fields>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #editDataFieldsModal
    [form]="editDataFieldsForm"
    (save)="onDataFieldsSave()"
    (cancel)="onCancel()"
    [secondaryActionText]="showAddCustomFieldsButton ? 'Add Custom Fields' : ''"
    (secondaryAction)="onAddCustomFields()"
>
    <app-form-data-fields
        #editDataFieldsForm
        [employee]="employee"
        [dataFieldGroup]="editFieldGroup"
        [dataFields]="editableDataFields"
        [(dataValues)]="dataValues"
    ></app-form-data-fields>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #editModalEc
    [form]="editFormEc"
    (save)="onSave()"
    (cancel)="onCancel()"
    headerText="{{ 'employees.personal.editEmergencyContacts' | appTranslate }}"
>
    <app-form-emergency-contacts
        #editFormEc
        [employee]="employee"
        *permission="editEmergencyContactPermission"
    ></app-form-emergency-contacts>
    <app-form-data-fields
        *ngIf="editModalEc.isOpen"
        [employee]="employee"
        [dataFieldGroup]="defaultGroupFieldNames.emergency_contacts"
        [dataFields]="editableDataFields"
        [(dataValues)]="dataValues"
        [isDefaultGroup]="true"
    ></app-form-data-fields>
</app-deprecated-modal-form>

<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-employee-header [employee]="employee" (isLoading)="isLoading = $event">
        <div class="buttons">
            <ng-container *ngIf="canCreateChangeRequest">
                <ui-button type="outline" [matMenu]="changeRequestMenu"
                    >{{ 'employees.personal.requestChange' | appTranslate }} <mat-icon svgIcon="chevronDown"></mat-icon>
                </ui-button>
                <mat-menu #changeRequestMenu="matMenu">
                    <button
                        *ngFor="let template of changeRequestTemplates"
                        mat-menu-item
                        [routerLink]="['/change-requests', 'templates', template.id, 'employees', employee.id, 'new']"
                    >
                        {{ template.name | appTranslateOptions: changeRequestTemplate }}
                    </button>
                </mat-menu>
            </ng-container>
        </div>
    </app-employee-header>

    <ng-container *permission="viewPersonalInformationPermissions">
        <app-warning-banner
            *ngIf="employee.isPayrollSyncEnabled && !!warningProvider"
            [warningsToDisplayProvider]="warningProvider"
        ></app-warning-banner>
    </ng-container>

    <ui-banner *ngIf="showLeaveOfAbsenceBanner" class="margin-bottom-2">
        {{ { key: 'employees.personal.leaveOfAbsenceBanner', params: { date: bannerDate } } | appTranslate }}
    </ui-banner>

    <div class="ui layout">
        <div class="sidebar">
            <app-profile-card [model]="employee"></app-profile-card>
        </div>
        <div class="content">
            @if (isUserProfile ? isKYCVisibleForCurrentUser() : isKYCVisibleForViewedEmployee()) {
                <ui-card class="profile-card" role="group" aria-labelledby="kyc-kyb-header">
                    <app-kyc-kyb-status scope="KYC" [employee]="isUserProfile ? undefined : employee" />
                </ui-card>
            }
            <div class="ui segment">
                <ui-button
                    type="link"
                    *ngIf="canShowEditBasicInformation"
                    (click)="editFormBasicInformation.show()"
                    class="edit"
                    >{{ 'employees.personal.edit' | appTranslate }}</ui-button
                >
                <app-segment-header
                    title="{{ 'employees.personal.basicInformation' | appTranslate }}"
                ></app-segment-header>
                <div class="app-grid margin-bottom-4">
                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                        <label>{{ 'employees.personal.firstName' | appTranslate }}</label>
                    </div>
                    <div class="columns-7">{{ employee?.firstName }}</div>
                </div>
                <div class="app-grid margin-bottom-4">
                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                        <label>{{ 'employees.personal.lastName' | appTranslate }}</label>
                    </div>
                    <div class="columns-7">{{ employee?.lastName }}</div>
                </div>
                <div class="app-grid margin-bottom-4">
                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                        <label>{{ 'employees.personal.phoneWork' | appTranslate }}</label>
                    </div>
                    <div class="columns-7">{{ employee?.phoneWork }}</div>
                </div>
                <!-- Gender & Pronouns -->
                <div *ngIf="employee?.genders?.length" class="app-grid margin-bottom-4">
                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                        <label>{{ 'employees.personal.gender' | appTranslate }}</label>
                    </div>
                    <div class="columns-7">
                        <ng-container *ngFor="let genderToDisplay of employee?.genders | genders; let last = last">
                            {{ genderToDisplay | appTranslate }}<span *ngIf="!last">,</span>
                        </ng-container>
                    </div>
                </div>
                <div *ngIf="employee?.pronouns?.length" class="app-grid margin-bottom-4">
                    <div class="columns-2 xl-columns-5 xxl-columns-4">
                        <label>{{ 'employees.personal.pronouns' | appTranslate }}</label>
                    </div>
                    <div class="columns-7">
                        <ng-container *ngFor="let pronounToDisplay of employee?.pronouns | pronouns; let last = last">
                            {{ pronounToDisplay | appTranslate }}<span *ngIf="!last">,</span>
                        </ng-container>
                    </div>
                </div>

                <app-deprecated-data-field-group-values
                    [group]="getDataFieldGroupByName(defaultGroupFieldNames.basic_information, dataFields, true)"
                    [dataFields]="dataFields"
                    [dataValues]="dataValues"
                ></app-deprecated-data-field-group-values>
            </div>
            <ng-container *ngIf="auth.canView(employee, 'id')">
                <ng-container *permission="viewPersonalInformationPermissions">
                    <div class="ui segment">
                        <ui-button
                            type="link"
                            *ngIf="canShowEditPersonalInformation"
                            (click)="editFormPersonalInformation.show()"
                            class="edit"
                            >{{ 'employees.personal.edit' | appTranslate }}</ui-button
                        >
                        <app-segment-header
                            title="{{ 'employees.personal.personalInformation' | appTranslate }}"
                        ></app-segment-header>
                        <!-- Show/Hide Legal Name based on Legal name permission -->
                        <ng-container *permission="viewPersonalInformationPermission">
                            <div class="app-grid margin-bottom-4">
                                <div class="columns-2 xl-columns-5 xxl-columns-4">
                                    <label>{{ 'employees.personal.legalFirstName' | appTranslate }}</label>
                                </div>
                                <div class="columns-7">{{ employee?.account?.legalFirstName }}</div>
                            </div>
                            <div class="app-grid margin-bottom-4">
                                <div class="columns-2 xl-columns-5 xxl-columns-4">
                                    <label>{{ 'employees.personal.legalMiddleName' | appTranslate }}</label>
                                </div>
                                <div class="columns-7">{{ employee?.account?.legalMiddleName }}</div>
                            </div>
                            <div class="app-grid margin-bottom-4">
                                <div class="columns-2 xl-columns-5 xxl-columns-4">
                                    <label>{{ 'employees.personal.legalLastName' | appTranslate }}</label>
                                </div>
                                <div class="columns-7">{{ employee?.account?.legalLastName }}</div>
                            </div>
                        </ng-container>
                        <!-- Show/Hide Legal Sex based on Legal sex permission -->
                        <ng-container *permission="viewLegalSexPermission">
                            <div class="app-grid margin-bottom-4">
                                <div class="columns-2 xl-columns-5 xxl-columns-4">
                                    <label>{{ 'employees.personal.legalSex' | appTranslate }}</label>
                                </div>
                                <div class="columns-7">{{ employee?.legalSex | legalSex | appTranslate }}</div>
                            </div>
                        </ng-container>
                        <div class="app-grid margin-bottom-4">
                            <div class="columns-2 xl-columns-5 xxl-columns-4">
                                <label>{{ 'employees.personal.phoneMobile' | appTranslate }}</label>
                            </div>
                            <div class="columns-7">{{ employee?.phoneMobile }}</div>
                        </div>
                        <div class="app-grid margin-bottom-4">
                            <div class="columns-2 xl-columns-5 xxl-columns-4">
                                <label>{{ 'employees.personal.phoneHome' | appTranslate }}</label>
                            </div>
                            <div class="columns-7">{{ employee?.phoneHome }}</div>
                        </div>
                        <div class="app-grid margin-bottom-4">
                            <div class="columns-2 xl-columns-5 xxl-columns-4">
                                <label>{{ 'employees.personal.dietaryRestrictions' | appTranslate }}</label>
                            </div>
                            <div class="columns-7">{{ employee?.dietaryRestrictions }}</div>
                        </div>
                        <!-- Show/Hide Date of birth on viewBornOn permission -->
                        <ng-container *permission="viewBornOnPermission">
                            <div class="app-grid margin-bottom-4">
                                <div class="columns-2 xl-columns-5 xxl-columns-4">
                                    <label>{{ 'employees.personal.dateOfBirth' | appTranslate }}</label>
                                </div>
                                <div *ngIf="employee?.bornOn" class="columns-7">
                                    {{ employee.bornOn | appDate: 'mediumDate' }}
                                    {{ 'employees.personal.age' | translate: { age: employee.age } }}
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="shouldShowBirthdayVisibility">
                            <div class="app-grid margin-bottom-4">
                                <div class="columns-2 xl-columns-5 xxl-columns-4">
                                    <label>{{ 'account.birthdayVisibility' | appTranslate }}</label>
                                </div>
                                <div class="columns-7">
                                    <div *ngIf="employee.isBirthdayPrivate; else birthdayPublic">
                                        {{ 'account.birthdayPrivateOption' | appTranslate }}
                                    </div>
                                    <ng-template #birthdayPublic>
                                        {{ 'account.birthdayPublicOption' | appTranslate }}</ng-template
                                    >
                                </div>
                            </div>
                        </ng-container>

                        <!-- Show/Hide SIN number on viewSin permission -->
                        <ng-container *permission="viewSinPermission">
                            <div class="app-grid margin-bottom-4">
                                <div class="columns-2 xl-columns-5 xxl-columns-4">
                                    <label>{{ 'employees.personal.sin' | appTranslate }}</label>
                                </div>
                                <div class="columns-7">
                                    <span class="blur">{{ employee?.sin }}</span>
                                </div>
                            </div>
                        </ng-container>

                        <app-deprecated-data-field-group-values
                            [group]="
                                getDataFieldGroupByName(defaultGroupFieldNames.personal_information, dataFields, true)
                            "
                            [dataFields]="dataFields"
                            [dataValues]="dataValues"
                        ></app-deprecated-data-field-group-values>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="auth.canView(employee, 'id')">
                <div *permission="viewAddressPermission" class="ui segment">
                    <ui-button type="link" *ngIf="canShowEditAddress" (click)="editFormAddress.show()" class="edit">{{
                        'employees.personal.edit' | appTranslate
                    }}</ui-button>
                    <app-segment-header title="{{ 'employees.personal.address' | appTranslate }}"></app-segment-header>
                    <div class="app-grid margin-bottom-4">
                        <div class="columns-2 xl-columns-5 xxl-columns-4">
                            <label>{{ 'employees.personal.streetAddress' | appTranslate }}</label>
                        </div>
                        <div class="columns-7">{{ address.addressLine1 }}</div>
                    </div>
                    <div class="app-grid margin-bottom-4">
                        <div class="columns-2 xl-columns-5 xxl-columns-4">
                            <label>{{ 'employees.personal.unitSuite' | appTranslate }}</label>
                        </div>
                        <div class="columns-7">{{ address.addressLine2 }}</div>
                    </div>
                    <div class="app-grid margin-bottom-4">
                        <div class="columns-2 xl-columns-5 xxl-columns-4">
                            <label>{{ 'employees.personal.city' | appTranslate }}</label>
                        </div>
                        <div class="columns-7">{{ address.city }}</div>
                    </div>
                    <div class="app-grid margin-bottom-4">
                        <div class="columns-2 xl-columns-5 xxl-columns-4">
                            <label>{{ 'employees.personal.postalCodeZip' | appTranslate }}</label>
                        </div>
                        <div class="columns-7">{{ address.postalCode }}</div>
                    </div>
                    <div class="app-grid margin-bottom-4">
                        <div class="columns-2 xl-columns-5 xxl-columns-4">
                            <label>{{ 'employees.personal.provinceState' | appTranslate }}</label>
                        </div>
                        <div class="columns-7">{{ address.provinceDisplayName }}</div>
                    </div>
                    <div class="app-grid margin-bottom-4">
                        <div class="columns-2 xl-columns-5 xxl-columns-4">
                            <label>{{ 'employees.personal.country' | appTranslate }}</label>
                        </div>
                        <div class="columns-7">{{ address.country | i18nCountry }}</div>
                    </div>

                    <app-deprecated-data-field-group-values
                        [group]="getDataFieldGroupByName(defaultGroupFieldNames.address, dataFields, true)"
                        [dataFields]="dataFields"
                        [dataValues]="dataValues"
                    ></app-deprecated-data-field-group-values>
                </div>
            </ng-container>

            <ng-container *ngIf="auth.canView(employee, 'id')">
                <div *permission="viewEmergencyContactPermission" class="ui segment">
                    <ui-button type="link" *ngIf="canShowEditEmergencyContact" (click)="editModalEc.show()" class="edit"
                        >{{ 'employees.personal.edit' | appTranslate }}
                    </ui-button>
                    <app-segment-header
                        title="{{ 'employees.personal.emergencyContacts' | appTranslate }}"
                    ></app-segment-header>
                    <div class="app-grid margin-bottom-4">
                        <div class="columns-2 xl-columns-5 xxl-columns-4">
                            <label>{{ 'employees.personal.primaryName' | appTranslate }}</label>
                        </div>
                        <div class="columns-7">{{ employee?.ecPrimaryName }}</div>
                    </div>
                    <div class="app-grid margin-bottom-4">
                        <div class="columns-2 xl-columns-5 xxl-columns-4">
                            <label>{{ 'employees.personal.primaryRelation' | appTranslate }}</label>
                        </div>
                        <div class="columns-7">{{ employee?.ecPrimaryRelation }}</div>
                    </div>
                    <div class="app-grid margin-bottom-4">
                        <div class="columns-2 xl-columns-5 xxl-columns-4">
                            <label>{{ 'employees.personal.primaryPhone' | appTranslate }}</label>
                        </div>
                        <div class="columns-7">{{ employee?.ecPrimaryPhone }}</div>
                    </div>
                    <div class="app-grid margin-bottom-4">
                        <div class="columns-2 xl-columns-5 xxl-columns-4">
                            <label>{{ 'employees.personal.secondaryName' | appTranslate }}</label>
                        </div>
                        <div class="columns-7">{{ employee?.ecSecondaryName }}</div>
                    </div>
                    <div class="app-grid margin-bottom-4">
                        <div class="columns-2 xl-columns-5 xxl-columns-4">
                            <label>{{ 'employees.personal.secondaryRelation' | appTranslate }}</label>
                        </div>
                        <div class="columns-7">{{ employee?.ecSecondaryRelation }}</div>
                    </div>
                    <div class="app-grid margin-bottom-4">
                        <div class="columns-2 xl-columns-5 xxl-columns-4">
                            <label>{{ 'employees.personal.secondaryPhone' | appTranslate }}</label>
                        </div>
                        <div class="columns-7">{{ employee?.ecSecondaryPhone }}</div>
                    </div>

                    <app-deprecated-data-field-group-values
                        [group]="getDataFieldGroupByName(defaultGroupFieldNames.emergency_contacts, dataFields, true)"
                        [dataFields]="dataFields"
                        [dataValues]="dataValues"
                    ></app-deprecated-data-field-group-values>
                </div>
            </ng-container>

            <app-data-field-groups
                *ngIf="dataFields && dataValues"
                [dataFields]="dataFields"
                [dataValues]="dataValues"
                [canEditDataValues]="canEditDataValues"
                component="personal"
                (edit)="onDataFieldEdit($event, editDataFieldsModal)"
            ></app-data-field-groups>
        </div>
    </div>
</div>
